<template>
    <div class="activity-modal input-full-width">
        <div class="modal-header">
            <h2 class="text-center">Tilføj aktiviteter fra skabelon</h2>
        </div>

        <div class="form">
            <div class="grid-x">
                <div class="small-1 cell flexbox-center">
                    <icon class="small-svg" name="file-text" />
                </div>
                <div class="small-3 cell">
                    <label for="select-activity">Skabelon</label>
                </div>
                <div class="auto cell">
                    <select v-model="selectedTemplate" id="select-template">
                        <option v-if="selectedSupplyType.id && taskTemplateList && taskTemplateList.length === 0" value="" disabled>Ingen skabeloner for {{selectedSupplyType.description | toLowerCase}}</option>
                        <option v-if="taskTemplateList && taskTemplateList.length > 0" value="" disabled="disabled">Vælg skabelon i listen</option>
                        <option v-if="taskTemplateList && taskTemplateList.length > 0" value="none">Ingen</option>
                        <optgroup v-if="recentTemplates.length > 0" label="Senest anvendte">
                            <option v-for="(template, index) in recentTemplates" :selected="template.name" :key="'recent-' + index" :value="template">
                                {{ template.name }}
                            </option>
                        </optgroup>
                        <optgroup v-if="recentTemplates.length > 0 && otherTemplates.length > 0" label="Øvrige">
                            <option v-for="(template, index) in otherTemplates" :selected="template.name" :key="'all-' + index" :value="template">
                                {{ template.name }}
                            </option>
                        </optgroup>
                        <option v-else v-for="(template, index) in otherTemplates" :selected="template.name" :key="'all-' + index" :value="template">
                            {{ template.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" @click="addTemplateToTask()">Tilføj</button>
                <button type="button" class="button-naked" @click="closeModal()">Annuller</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'task-modal-activity-template',
    data () {
        return {
            selectedTemplate: ''
        }
    },
    computed: {
        ...mapGetters({
            getActiveTaskId: 'getActiveTaskId',
            taskTemplateList: 'getTaskTemplateList',
            selectedSupplyType: 'selectedSupplyType'
        }),

        sortedTaskTemplateList () {
            if (this.taskTemplateList) {
                return [...this.taskTemplateList].filter(template => template.businessAreaTypeId === this.selectedSupplyType.id).sort(function (a, b) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1 }
                    if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1 }
                    return 0
                })
            }
            return []
        },
        recentTemplates () {
            const recent = this.getRecentTemplatesFromStorage()
            if (this.taskTemplateList && recent.length > 0) {
                const totalCount = this.sortedTaskTemplateList.length
                const maxRecent = totalCount >= 30 ? 10 : (totalCount >= 15 ? 5 : 0)

                if (maxRecent === 0) return []

                // Filter to only include templates that exist in the current supply type
                return recent
                    .map(templateId => this.taskTemplateList.find(t => t.taskId === templateId && t.businessAreaTypeId === this.selectedSupplyType.id))
                    .filter(template => template !== undefined)
                    .slice(0, maxRecent)
            }
            return []
        },
        otherTemplates () {
            if (this.sortedTaskTemplateList.length < 15) {
                return this.sortedTaskTemplateList
            }
            if (this.recentTemplates.length > 0) {
                const recentIds = this.recentTemplates.map(t => t.taskId)
                return this.sortedTaskTemplateList.filter(template => !recentIds.includes(template.taskId))
            }
            return this.sortedTaskTemplateList
        }
    },
    methods: {
        ...mapActions({
            getActivitiesFromTemplate: 'getActivitiesFromTemplate'
        }),

        getRecentTemplatesFromStorage () {
            try {
                const stored = localStorage.getItem(`recent${String(this.selectedSupplyType.systemName).charAt(0).toUpperCase() + String(this.selectedSupplyType.systemName).slice(1)}TaskTemplates`)
                return stored ? JSON.parse(stored) : []
            } catch (e) {
                console.error('Error reading recent templates from localStorage:', e)
                return []
            }
        },
        saveRecentTemplateToStorage (templateId) {
            if (!templateId) return

            try {
                let recent = this.getRecentTemplatesFromStorage()

                // Remove if already exists
                recent = recent.filter(id => id !== templateId)

                // Add to beginning
                recent.unshift(templateId)

                // Keep only the 10 most recent
                recent = recent.slice(0, 10)

                localStorage.setItem(`recent${String(this.selectedSupplyType.systemName).charAt(0).toUpperCase() + String(this.selectedSupplyType.systemName).slice(1)}TaskTemplates`, JSON.stringify(recent))
            } catch (e) {
                console.error('Error saving recent template to localStorage:', e)
            }
        },
        closeModal () {
            this.$emit('close')
        },
        addTemplateToTask () {
            if (this.selectedTemplate !== '') {
                this.getActivitiesFromTemplate({
                    templateId: this.selectedTemplate.taskId,
                    taskId: this.getActiveTaskId
                })
                    .then(() => {
                        this.saveRecentTemplateToStorage(this.selectedTemplate.taskId)
                        this.closeModal()
                    })
            } else {
                this.closeModal()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/task/task-modal-activity-template.vue